/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import defaultImg from 'Assets/images/commons/default-img.jpg';
import { useEffect, useState } from 'react';
import { Icon, Loader } from 'semantic-ui-react';

const PrivateImage = ({ src, onClick, className, style, ...rest }) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetch(src, {
      method: 'GET',
      credentials: 'include',
    })
      .then(response => {
        if (!response.ok) {
          setError(response.statusText);
          setLoading(false);
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.blob())
      .then(blob => {
        setLoading(false);
        setImgSrc(URL.createObjectURL(blob));
      })
      .catch(() => {
        setImgSrc(defaultImg);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [src]);

  return (
    <>
      {loading && <Loader active inline />}
      {imgSrc && (
        <img
          alt="auth img"
          style={{ maxHeight: '100%', maxWidth: '100%', ...style }}
          className={className}
          src={imgSrc}
          onClick={onClick}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
        />
      )}
      {error && <Icon name="file image outline" size="large" />}
    </>
  );
};

export default PrivateImage;
